import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { INavigation } from '@models/navigation';
import { IPermissionCheck, PermissionCheck } from '@models/role';
import { ROUTES } from '@utils/constants';
import { IUserDTO, UserDTO } from '@models/user';

@Component({
  selector: 'app-top-navigation-presentation',
  templateUrl: './top-navigation-presentation.component.html',
  styleUrls: ['./top-navigation-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavigationPresentationComponent {
  @Input() public isValid: boolean = false;
  @Input() public loggedInUser: IUserDTO = new UserDTO();
  @Input() public navLinks: INavigation[];
  @Input() public permissionCheck: IPermissionCheck = new PermissionCheck();
  @Input() public profileLinks: INavigation[];
  @Input() public route: string = '';

  public isMenuCollapsed = true;
  public loginPath: string = `/${ROUTES.auth.login.path}`;
  public signUpPath: string = `/${ROUTES.auth.accountType.path}`;
}
